



































































/** @format */

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ZhaohangPay from './zhaohang-pay.vue';
import JiaohangPay from './jiaohang-pay.vue';
import UnifiedPay from './unified-pay.vue';
import UnionPay from './union-pay.vue';
import BillingCenter from './billing-center.vue';
import {
  DictBizType,
  dictBizTypeMap,
  IZhaohangData,
  IJiaohangData,
  IUnionData,
  IUnifiedData,
  IUnifiedDatacenter
} from './type';

@Component({
  components: { ZhaohangPay, JiaohangPay, UnifiedPay, UnionPay, BillingCenter }
})
export default class FormWrap extends Vue {
  private payTypeMap = {
    '00': '招行支付',
    '03': '统一支付',
    '01': '微信支付',
    '02': '支付宝支付',
    '04': '富友支付',
    '05': '银联支付',
    '06': '交行支付',
    '07': '中行支付',
    '08': '通联支付',
    '09': '账单中心',
    '11': '银联条码',
    '10': '兴业银行'
  };
  @Prop()
  bizType!: any;

  @Prop()
  payPlatOption!: any[];

  @Prop()
  formData!: any;

  @Prop({ type: Boolean, default: false })
  isDisabled!: boolean;
  onchange(value: string) {
    this.payType = value || '';
    this.$emit('changePayType', { payType: value });
  }
  payType = this.formData && this.formData.payType;
  allowEditSwitch = this.formData && this.formData.allowEditSwitch;
  private zhaohangData: IZhaohangData | undefined;

  // 表单布局
  private formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 }
    }
  };

  get bizTypeTitle() {
    if (this.bizType) {
      return dictBizTypeMap[this.bizType] || '';
    } else {
      return '';
    }
  }

  @Watch('formData')
  formDataChange(newVal: any) {
    this.payType = (newVal && newVal.payType) || '';
    if (newVal && newVal.allowEditSwitch) {
      this.allowEditSwitch = newVal.allowEditSwitch == '00';
    } else {
      this.allowEditSwitch = true;
    }
  }

  zhaohangChange(value: IZhaohangData) {
    this.$emit('change', {
      bizType: this.bizType,
      payType: this.payType,
      ...value
    });
  }
  jiaohangChange(value: IJiaohangData) {
    this.$emit('change', {
      bizType: this.bizType,
      payType: this.payType,
      ...value
    });
  }
  unionChange(value: IUnionData) {
    this.$emit('change', {
      bizType: this.bizType,
      payType: this.payType,
      ...value
    });
  }
  unifiedChange(value: IUnifiedData) {
    this.$emit('change', {
      bizType: this.bizType,
      payType: this.payType,
      ...value
    });
  }
  zhangdanChange(value: IUnifiedDatacenter) {
    this.$emit('change', {
      bizType: this.bizType,
      payType: this.payType,
      ...value
    });
  }
  //获取是否开启支付开关
  getAllowEditSwitch() {
    return this.allowEditSwitch ? '00' : '01';
  }

  // 生命周期初始化
  async created() {}
}
